// src/components/admin/ClientRecipeDetail/ClientRecipeDetail.js
import React from 'react';
import styles from './RecipeDetail.module.css';
import SupportGallery from "@/ui/components/admin/AdminSupportGallery/SupportGallery";
import PreparationSteps from "@/ui/components/admin/AdminPreparationSteps/PreparationSteps";
import IngredientsManager from "@/ui/components/admin/AdminIngredientsManager/IngredientsManager";
import RecipeCard from "@/ui/components/admin/AdminRecipeCard/RecipeCard";

function RecipeDetail({ recipe, onBack }) {
    if (!recipe) {
        return (
            <div className={styles.errorContainer}>
                <div className={styles.errorCard}>
                    <span className={styles.errorIcon}>⚠️</span>
                    <h2>Receta no encontrada</h2>
                    <p>La receta que buscas no existe o ha sido eliminada.</p>
                    <button onClick={onBack} className={styles.backBtn}>
                        ← Volver
                    </button>
                </div>
            </div>
        );
    }

    // Normalizar los datos de la receta
    const normalizedRecipe = {
        name: recipe.name || "Sin nombre",
        image: recipe.image || recipe.image_url || recipe.photo || null,
        image_url: recipe.image_url || recipe.image || null,
        price: recipe.price || 0,
        time: recipe.prep_time || recipe.time || "N/A",
        servings: recipe.servings || recipe.portion || "N/A",
        ingredients: recipe.ingredients || [],
        preparation_steps: recipe.preparation_steps || recipe.steps || [],
        gallery: recipe.gallery || []
    };

    return (
        <div className={styles.recipeDetailContainer}>
            <div className={styles.recipeCard}>
                {/* Header */}
                <div className={styles.header}>
                    <button onClick={onBack} className={styles.backButton}>
                        <span className={styles.backIcon}>←</span>
                        Volver
                    </button>
                    <h1 className={styles.title}>Detalle de la receta</h1>
                    <button className={styles.editBtn}>
                        <span className={styles.editIcon}>✏️</span>
                        Editar
                    </button>
                </div>

                {/* Recipe Card */}
                <div className={styles.recipeCardSection}>
                    <RecipeCard
                        name={normalizedRecipe.name}
                        image={normalizedRecipe.image}
                    />
                </div>



                {/* Ingredients Section */}
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <span className={styles.sectionIcon}>🥘</span>
                        <h3 className={styles.sectionTitle}>Ingredientes</h3>
                    </div>
                    <IngredientsManager ingredients={normalizedRecipe.ingredients} />
                </div>

                {/* Preparation Steps Section */}
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <span className={styles.sectionIcon}>📝</span>
                        <h3 className={styles.sectionTitle}>Pasos de preparación</h3>
                    </div>
                    <PreparationSteps preparation={normalizedRecipe.preparation_steps} />
                </div>

                {/* Gallery Section */}
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <span className={styles.sectionIcon}>🖼️</span>
                        <h3 className={styles.sectionTitle}>
                            Galería de apoyo
                            <span className={styles.optional}>(opcional)</span>
                        </h3>
                    </div>
                    <SupportGallery gallery={normalizedRecipe.gallery} />
                </div>
            </div>
        </div>
    );
}

export default RecipeDetail;